import React from 'react';
import ReactMarkdown from 'react-markdown';
import ExerciseResults from '../shared/ExerciseResults';

const Results = ({ questions, userAnswers, evaluations, restart, onBack, engagementData, engagementLoading }) => {
  // Create a map of evaluations by question_id for easy lookup
  const evaluationMap = {};
  evaluations.forEach(evaluation => {
    evaluationMap[evaluation.question_id] = evaluation;
  });

  const getScore = () => {
    let correct = 0;
    questions.forEach(q => {
      const evaluation = evaluationMap[q.id];
      if (evaluation && evaluation.is_correct) {
        correct++;
      }
    });
    return correct;
  };

  const score = getScore();
  const totalQuestions = questions.length;

  return (
    <ExerciseResults
      title="Výsledky - Konverzace"
      score={score}
      total={totalQuestions}
      color="blue"
      onRestart={restart}
      onBack={onBack}
      engagementData={engagementData}
      engagementLoading={engagementLoading}
    >
      {/* Detailed Results */}
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Detailní výsledky
      </h3>

      <div className="flex flex-col gap-3">
        {questions.map((q, index) => {
          const evaluation = evaluationMap[q.id];
          const isCorrect = evaluation && evaluation.is_correct;

          return (
            <div
              key={q.id}
              className={`p-4 rounded-lg ${
                isCorrect
                  ? 'bg-green-50'
                  : 'bg-red-50'
              }`}
            >
              <div className="flex items-start gap-3">
                <span className="text-blue-600 font-semibold min-w-[30px]">
                  #{index + 1}
                </span>
                <div className="flex-1">
                  <div className="text-gray-800 font-medium mb-2">
                    {q.question}
                  </div>
                  <div className="text-sm text-gray-600 mb-1">
                    <strong>Vaše odpověď:</strong> {userAnswers[q.id] || '(nezodpovězeno)'}
                  </div>
                  <div className="text-sm text-gray-600 mb-2">
                    <strong>Správná odpověď:</strong> {q.answer}
                    {q.alternative_answers && q.alternative_answers.length > 0 && (
                      <span className="text-gray-500">
                        {' '}(další: {q.alternative_answers.join(', ')})
                      </span>
                    )}
                  </div>
                  {evaluation && (
                    <div className="text-sm text-gray-600 mt-3 p-3 bg-white rounded-lg">
                      <strong>Hodnocení:</strong>{' '}
                      <ReactMarkdown components={{
                        p: ({children}) => <span>{children}</span>,
                        strong: ({children}) => <strong className="text-gray-800">{children}</strong>
                      }}>{evaluation.evaluation}</ReactMarkdown>
                    </div>
                  )}
                  <div className={`text-sm font-medium mt-2 ${
                    isCorrect ? 'text-green-600' : 'text-red-500'
                  }`}>
                    {isCorrect ? '✓ Správně' : '✗ Špatně'}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ExerciseResults>
  );
};

export default Results;
